<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <h3 class="text-center">
            Add and View Partnerships <span class="smh"></span>
          </h3>
        </b-col>
        <b-col cols="12">
          <div class="text-center">
            <div class="">
              <b-button
                class="v-button px-4 mt-3 mb-2"
                @click="opencreate = !opencreate"
                variant="success"
                >Create a Partnership</b-button
              >
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="opencreate == true">
        <b-col class="m-1 p-3">
          <form @submit.prevent="createPartner">
            <b-form-group
              label="Partnership Title"
              class="label"
              label-for="target"
            >
              <b-form-input
                type="text"
                id="title"
                v-model="create.title"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Partnership Description"
              label-for="title"
              class="label"
            >
              <b-form-textarea
                type="text"
                id="description"
                v-model="create.description"
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Partners Share" label-for="markper">
              <b-form-spinbutton
                id="markper"
                v-model="create.share"
                min="1"
                max="100"
                step="1"
              ></b-form-spinbutton>
            </b-form-group>

            <b-form-group
              label="Organization Fullname"
              label-for="code"
              class="label"
            >
              <div class="flex-input-parent">
                <div
                  :class="{
                    'left-flex-child': isCheckingorg,
                    'full-width-child': !isCheckingorg
                  }"
                >
                  <b-form-input
                    type="text"
                    id="organization"
                    v-model="create.organization"
                    @input="checkOrganization(create.organization, 'name')"
                  ></b-form-input>
                </div>
                <div
                  :class="{
                    'right-flex-child': isCheckingorg,
                    hidden: !isCheckingorg
                  }"
                >
                  <b-icon-x
                    font-scale="2"
                    variant="danger"
                    v-if="orgexists == true"
                  ></b-icon-x>
                  <b-icon-check
                    font-scale="2"
                    variant="success"
                    v-if="orgexists == false"
                  ></b-icon-check>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label="Organization Shortname"
              label-for="code"
              class="label"
            >
              <div class="flex-input-parent">
                <div
                  :class="{
                    'left-flex-child': isCheckingorgsn,
                    'full-width-child': !isCheckingorgsn
                  }"
                >
                  <b-form-input
                    type="text"
                    id="organization"
                    v-model="create.organizationsn"
                    @input="checkOrganization(create.organizationsn, 'sn')"
                  ></b-form-input>
                </div>
                <div
                  :class="{
                    'right-flex-child': isCheckingorgsn,
                    hidden: !isCheckingorgsn
                  }"
                >
                  <b-icon-x
                    font-scale="2"
                    variant="danger"
                    v-if="snexists == true"
                  ></b-icon-x>
                  <b-icon-check
                    font-scale="2"
                    variant="success"
                    v-if="snexists == false"
                  ></b-icon-check>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label="Organization Email"
              label-for="code"
              class="label"
            >
              <div class="flex-input-parent">
                <div
                  :class="{
                    'left-flex-child': isCheckingorgemail,
                    'full-width-child': !isCheckingorgemail
                  }"
                >
                  <b-form-input
                    type="email"
                    id="organization"
                    v-model="create.org_email"
                    @input="checkOrganization(create.org_email, 'email')"
                  ></b-form-input>
                </div>
                <div
                  :class="{
                    'right-flex-child': isCheckingorgemail,
                    hidden: !isCheckingorgemail
                  }"
                >
                  <b-icon-x
                    font-scale="2"
                    variant="danger"
                    v-if="emailexists == true"
                  ></b-icon-x>
                  <b-icon-check
                    font-scale="2"
                    variant="success"
                    v-if="emailexists == false"
                  ></b-icon-check>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label="Partnership Code"
              label-for="code"
              class="label"
            >
              <b-form-input
                type="text"
                disabled
                id="code"
                v-model="create.code"
              ></b-form-input>
              <b-button
                :disabled="create.organization.length == 0"
                variant="success"
                class="mt-1"
                @click="generateCode"
                >Generate Code</b-button
              >
            </b-form-group>

            <b-form-group
              label="Partnership Terms"
              label-for="title"
              class="label"
            >
              <vue2-tinymce-editor v-model="create.terms"></vue2-tinymce-editor>
            </b-form-group>

            <b-overlay :show="uploadingfile">
              <template #overlay>
                <div class="text-center">
                  <b-icon-file-image
                    font-scale="3"
                    animation="throb"
                  ></b-icon-file-image>
                  <p>Uploading File... Checking Semantics</p>
                </div>
              </template>
              <!-- <b-form-group label="Upload Partnership Terms in Pdf">
                        <b-form-file :disabled="chkentries" variant="warning" v-model="filelink" ref="uploadfile" placeholder="Choose a file or drop it here" drop-placeholder="Drop File here..." @input="handleFileUpload"></b-form-file>
                    </b-form-group> -->
              <div v-if="mtype == 'Ready!'" class="font-green">
                <b-icon-check-circle-fill
                  variant="success"
                  font-scale="1.2"
                ></b-icon-check-circle-fill>
                File has been uploaded successfully
              </div>
            </b-overlay>

            <div
              v-if="sent"
              class="alert p-3"
              :class="'alert-' + addresponse.status"
            >
              {{ addresponse.msg }}
            </div>

            <b-form-group>
              <div class="text-center">
                <b-overlay
                  :show="sending"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="primary"
                  class=""
                >
                  <div class="mt-4">
                    <b-button
                      :disabled="chkfields"
                      type="submit"
                      variant="outline-success"
                      class="m-lg-3 mt-2 p-2 action-button"
                    >
                      Create Partnership
                    </b-button>
                  </div>
                </b-overlay>
              </div>
            </b-form-group>
          </form>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="">
          <h3 class="text-center">Partnerships</h3>

          <div class="maxres">
            <div class="text-center list-heads pt-1">
              <p class="head-p">S/N</p>
              <p class="head-p">Title</p>
              <p class="head-p">Organization</p>
              <p class="head-p">Code</p>
              <p class="head-p">Profit Share</p>
              <p class="head-p">Users</p>
              <p class="head-p">Earnings</p>
              <p class="head-p">Upgrades</p>
              <p class="head-p"></p>
            </div>

            <div v-if="partnershipsarray[0].count > 0">
              <partnerships-list
                class="mt-2"
                v-for="(partnership, index) in usepartnershipsarray"
                :sn="index + 1"
                :partnership="partnership"
                :key="index"
                :page="pages"
                :interval="intervalnum"
              ></partnerships-list>
            </div>
            <div v-else>
              <h3>No Partnership Yet</h3>
            </div>
          </div>
          <paginater
            v-if="partnershipsarray[0].data.length > 0"
            :intervalnum="intervalnum"
            :pages="pages"
            :endss="endss"
            :endnum="endnum"
            :datalength="endss"
            @paginator="newPage"
            @changeInterval="effectInterval"
          ></paginater>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";
import partnershipsList from "@/components/admin/partnershipsList";
import Paginater from "@/components/Paginater";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import axios from "axios";

export default {
  components: {
    partnershipsList,
    Paginater,
    Vue2TinymceEditor
  },

  data() {
    return {
      create: this.getForm(),
      sending: false,
      sent: false,
      levels: [0, 1, 2, 3, 4, 5],
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      addresponse: "",
      opencreate: false,
      isCheckingorg: false,
      orgexists: false,
      snexists: false,
      emailexists: false,
      uploadingfile: false,
      uploadedfile: false,
      uploadmessage: "",
      mtype: "",
      filedir: ""
      // datacount : this.partnershipsarray[0].count
    };
  },
  beforeRouteEnter(to, from, next) {
    //   let orgname = store.state.loginmaster.details.clearance_organization
    store.dispatch("admin/fetchPartnerships").then(() => {
      next();
    });
  },
  computed: {
    ...mapState({
      users: state => state.admin.allusers,
      details: state => state.loginmaster.details,
      partnershipsarray: state => state.admin.partnerships,
      adminadded: state => state.admin.adminadded,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.api_origin
    }),
    emails() {
      let emailss = this.users;
      return emailss.map(x => x.email);
    },
    usepartnershipsarray() {
      return this.partnershipsarray[0].data.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.partnershipsarray[0].data.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(
        this.partnershipsarray[0].data.length / this.intervalnum
      );
      return ranger;
    },
    chkfields() {
      if (
        this.orgexists ||
        this.emailexists ||
        this.snexists ||
        this.sending ||
        this.create.code.length <= 0 ||
        this.create.organization.length <= 0 ||
        this.create.description.length <= 0 ||
        this.create.title.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("admin", [
      "createPartnership",
      "fetchPartnerships",
      "checkPartCode",
      "checkPartOrganization",
      "generatePartCode"
    ]),
    getForm() {
      return {
        email: "",
        share: 1,
        terms: "",
        code: "",
        title: "",
        description: "",
        organization: "",
        organizationsn: "",
        org_email: "",
        filedir: ""
      };
    },
    createPartner() {
      this.sending = true;

      return this.createPartnership(this.create).then(response => {
        this.sending = false;
        this.sent = true;
        this.addresponse = response;

        this.fetchPartnerships();

        this.$bvModal
          .msgBoxOk(`${this.addresponse.msg}.`, {
            title: "Operation Successful",
            size: "xs",
            centered: true
          })
          .then(() => {});
      });
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },

    checkOrganization(value, column) {
      this.create.organization =
        this.create.organization.charAt(0).toUpperCase() +
        this.create.organization.slice(1);
      this.create.organizationsn = this.create.organizationsn.toUpperCase();

      if (column == "name") {
        if (this.create.organization.length > 0) {
          this.isCheckingorg = true;
        } else {
          this.isCheckingorg = false;
        }
      } else if (column == "sn") {
        if (this.create.organizationsn.length > 0) {
          this.isCheckingorgsn = true;
        } else {
          this.isCheckingorgsn = false;
        }
      } else if (column == "email") {
        if (this.create.org_email.length > 0) {
          this.isCheckingorgemail = true;
        } else {
          this.isCheckingorgemail = false;
        }
      }

      const payload = {
        value,
        column
      };

      return this.checkPartOrganization(payload).then(response => {
        this.orgexists = response;
        if (column == "name") {
          this.orgexists = response;
        } else if (column == "sn") {
          this.snexists = response;
        } else if (column == "email") {
          this.emailexists = response;
        }
        // console.log(response)
      });
    },

    generateCode() {
      return this.generatePartCode(this.create.organizationsn).then(
        response => {
          this.create.code = response;
        }
      );
    },
    handleFileUpload() {
      let filelength = this.$refs.uploadfile.files[0].name.length;
      // console.log(filelength)

      if (filelength > 0) {
        this.uploadingfile = true;
        let ifile = this.$refs.uploadfile.files[0];
        let formData = new FormData();

        formData.append("filetoupload", ifile);
        formData.append("uploadcategory", "Partnership");
        formData.append("environment", this.environ);
        formData.append("pretag", "partnerships");
        formData.append("origin", this.origin);
        let apilink =
          this.environ == "development"
            ? `${this.origin}/Filehandler.php`
            : `${this.origin}/Filehandler.php`;

        axios
          .post(apilink, formData, {
            header: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            // console.log(response.data)
            this.uploadmessage = response.data.message;
            this.uploadingfile = false;
            this.mtype = response.data.mtype;
            this.filelink = "";
            this.$bvModal
              .msgBoxOk("Terms File has been Uploaded Successfully", {
                title: "Terms of Partnership Uploaded",
                size: "xs",
                centered: true
              })
              .then(() => {});
            this.filedir = response.data.filedir;

            //console.log(response.data);
          })
          .catch(() => {
            //console.log(error)
            this.$bvModal
              .msgBoxOk(
                "Check your Network Connection. Could not upload Question File.",
                {
                  title: "No Network Connection",
                  size: "xs",
                  centered: true
                }
              )
              .then(() => {
                this.filelink = "";
                this.uploadingfile = false;
              });
            //console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped>
.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  width: 1200px;
  display: flex;
  flex-flow: row nowrap;
  overflow-x: auto;
}
.head-p {
  width: 130px;
  margin-right: 2px;
}

.maxres {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #00984a;
}
.flex-input-parent {
  display: flex;
}
.left-flex-child {
  width: 95%;
}
.right-flex-child {
  width: 5%;
}
.hidden {
  display: none;
}
.full-width-child {
  width: 100%;
}
.font-green {
  color: green;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
